module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-ru-RU.8cf10b6a.jpg";